import { useTranslation } from 'react-i18next'

import imgUrl from '../assets/img/try-premium.jpeg'
import { Button } from '../components/Button'

export const TryPremiumModal = ({ onConfirm }: ModalProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col py-4">
      <p className="mb-5 text-center text-2xl">{t('tryPremium')}</p>

      <img src={imgUrl} alt="mobile phone" className="mb-5" />

      <p className="mb-4 px-4">{t('tryPremiumText')}</p>
      <p className="mb-4 px-4">{t('tryPremiumText')}</p>
      <p className="mb-4 px-4">{t('tryPremiumText')}</p>
      <div className="px-4">
        <Button
          text={t('tryPremiumForFree')}
          type="button"
          onClick={onConfirm}
          variant="primary"
          className="w-full text-white"
        />
      </div>
    </div>
  )
}
